import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class EditorDialogStore {
  private readonly _dialog$ = new BehaviorSubject<string>(null);

  readonly dialog$ = this._dialog$.asObservable();

  constructor() {

  }

  private get dialog(): string {
    return this._dialog$.getValue();
  }

  private set dialog(value: string) {
    this._dialog$.next(value);
  }

  editBookingItem() {
    this.dialog = 'bookingItem';
  }

  editBookingItemRoot() {
    this.dialog = 'bookingItemRoot';
  }

  editBookingItemTree() {
    this.dialog = 'bookingItemTree';
  }

  stopEditing() {
    this.dialog = null;
  }
}
